var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 11.207 18.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_18994945",
    transform: "translate(0.4 0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M119.972,28.584h-7.536A1.435,1.435,0,0,1,111,27.149V12.435A1.435,1.435,0,0,1,112.435,11h7.536a1.435,1.435,0,0,1,1.435,1.435V27.149A1.435,1.435,0,0,1,119.972,28.584Z",
    transform: "translate(-111 -11)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 2.678,
    transform: "translate(3.864 16.005)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M203.555,11v.5a1.077,1.077,0,0,1-1.077,1.077h-1.9A1.077,1.077,0,0,1,199.5,11.5V11",
    transform: "translate(-196.324 -11)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(2.594 6.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M233.418,239.885l-1.157,1.157-.59-.589",
    transform: "translate(-229.936 -237.854)",
    fill: "none",
    stroke: "#19b21a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 2.609,
    cy: 2.609,
    r: 2.609,
    fill: "none",
    stroke: "#19b21a",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileChecked);
export default __webpack_public_path__ + "static/media/mobile-checked.bc4ee3377abdc2d158c015c087f386ba.svg";
export { ForwardRef as ReactComponent };